export enum HyperlinkBehavior {
  OpenInSamePage = 0,
  OpenInNewTab = 1,
  OpenInNewWindow = 2,
  OpenInEngineContext = 3
}
